import { useMemo } from 'react'
import ModalProviders from '../common/providers/ModalProviders'
import CommonDrawerContextProviders, { useLinkedCommonDrawerState } from '../common/context/CommonDrawerContexts'
import { getVarValue, globalDispatch } from '../common/utils/Sparky'
import Tenancy from '../tenancy'
import { selectTreeNode } from '../common/reducers/actions/TreeReducer.actions'
import { LoadingPlaceholder } from '@sparky/framework'
import Header from './Header'
import MessageProvider from '../common/providers/MessageProvider'
import { VIEW_MANAGE_TENANT } from '../common/constants/GlobalConstants'
import useSelectedTsg from './useSelectedTsg'
import type { VFC } from 'react'
import type { CommonModuleProps } from '../common/types'
import { FF_DEFAULT_TSG } from '../common/utils/FeatureFlags'

const showSubscriptions = getVarValue('show_subscriptions', false)
const enableDefaultTSG = getVarValue(FF_DEFAULT_TSG)

const TenantManagement: VFC<CommonModuleProps> = ({ auth, commonModule, location }) => {
  const {
    treeReducer,
    viewReducer,
    instanceReducer,
    appReducer,
    licenseReducer,
    iamReducer,
    deviceReducer,
    subscriptionReducer,
    dispatch,
    initializing,
  } = useLinkedCommonDrawerState()

  const props = useMemo(() => {
    const onBreadCrumbClick = (obj: any) => {
      dispatch(selectTreeNode(obj))
    }
    return {
      ...appReducer,
      ...treeReducer,
      ...viewReducer,
      ...instanceReducer,
      currentView: commonModule?.path || '',
      showSubscriptions,
      dispatch,
      iamReducer,
      licenseReducer,
      deviceReducer,
      globalDispatch,
      onBreadCrumbClick,
      commonModule: {
        ...commonModule,
        path: VIEW_MANAGE_TENANT,
        visible: true,
      },
      subscriptionReducer,
      inCommonServicesPage: true,
      auth
    }
  }, [appReducer, auth, commonModule, deviceReducer, dispatch, iamReducer, instanceReducer, licenseReducer, subscriptionReducer, treeReducer, viewReducer])

  const header = useMemo(() => {
    if (enableDefaultTSG) {
      return <Header title={auth?.tsgs?.hasMsp ? 'Tenants' : 'Products'} />
    }
    return <Header title={'Tenants'} />
  }, [auth?.tsgs?.hasMsp])

  useSelectedTsg(location)

  if (initializing) {
    return <LoadingPlaceholder />
  }
  return (
    <div className='cm-w-full cm-h-full cm-flex cm-flex-col'>
      <CommonDrawerContextProviders>
        <ModalProviders>
          {header}
          <div className='cm-relative cm-flex-1 cm-bg-white dark:cm-bg-gray-1050'>
            <MessageProvider>
              <Tenancy {...props} />
            </MessageProvider>
          </div>
        </ModalProviders>
      </CommonDrawerContextProviders>
    </div>
  )
}
export default TenantManagement
